<template>
  <div id="wrapper">
    <v-app>
      <div class="highlight" v-if="showBanner">Preencha os dados do seu supermercado <a href="/dashboard/profile">Clicando aqui</a></div>
      <SideMenu />
      <div id="page-wrapper" class="gray-bg">
        <Breadcrumbs />
        <router-view />
      </div>
    </v-app>
  </div>
</template>

<style lang="scss">
     @import '../../assets/admin/css/bootstrap.min.css';
     @import '../../assets/admin/font-awesome/css/font-awesome.css';
     @import '../../assets/admin/css/plugins/morris/morris-0.4.3.min.css';
     @import '../../assets/admin/js/plugins/gritter/jquery.gritter.css';
     @import '../../assets/admin/css/animate.css';
     @import '../../assets/admin/css/style.css';

     .highlight {
       background-color: #ff0;
       color: #000;
       padding: 10px;

       a {
         text-decoration: underline;
         font-weight: bold;
       }
     }
</style>

<script>
/* eslint-disable */
import SideMenu from "@/views/admin/components/SideMenu.vue";
import Breadcrumbs from "@/views/admin/components/Breadcrumbs.vue";
import FooterAdmin from "@/views/admin/components/FooterAdmin.vue";
import { mapGetters } from "vuex";


export default {

  computed: {
    ...mapGetters(["authUser", "userData"]),
  },

  components: {
    SideMenu,
    Breadcrumbs,
    FooterAdmin
  },

  methods: {
    createScript(src) {
      let scriptTag = document.createElement("script");
      scriptTag.async = true;
      scriptTag.defer = true;
      scriptTag.setAttribute("src", src);
      document.body.appendChild(scriptTag);
    },
  },

  data() {
    return {
      showBanner: false
    };
  },

  beforeCreate() {
    if(!document.body.classList.contains('gray-bg')) document.body.classList.add('gray-bg');
  },

  mounted() {
    this.$data.showBanner = this.$router.currentRoute.name !== 'Profile' && this.userData && this.userData.type === 'supermarket' && !this.userData.cnpj;
  },

  updated() {
    this.$data.showBanner = this.$router.currentRoute.name !== 'Profile' && this.userData && this.userData.type === 'supermarket' && !this.userData.cnpj;
  },
};
</script>

